var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3305_2288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 8.74984H2.33366C2.02424 8.74984 1.72749 8.62692 1.5087 8.40813C1.28991 8.18934 1.16699 7.89259 1.16699 7.58317V2.33317C1.16699 2.02375 1.28991 1.72701 1.5087 1.50821C1.72749 1.28942 2.02424 1.1665 2.33366 1.1665H7.58366C7.89308 1.1665 8.18982 1.28942 8.40862 1.50821C8.62741 1.72701 8.75033 2.02375 8.75033 2.33317V2.9165M6.41699 5.24984H11.667C12.3113 5.24984 12.8337 5.77217 12.8337 6.4165V11.6665C12.8337 12.3108 12.3113 12.8332 11.667 12.8332H6.41699C5.77266 12.8332 5.25033 12.3108 5.25033 11.6665V6.4165C5.25033 5.77217 5.77266 5.24984 6.41699 5.24984Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3305_2288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.3aa2c256301fd126e9b2dbd55db19f06.svg";
export { ForwardRef as ReactComponent };